import { Match, MatchTeam } from "@/models/match.model";

export default class MatchUtils {
  static isMatchFinished(match: Match) {
    const startDate = new Date(match.start_time);
    startDate.setMinutes(startDate.getMinutes() + Number.parseInt(match.length));

    return startDate <= new Date();
  }

  static getWinnerId(homeTeam: MatchTeam, awayTeam: MatchTeam): number | null {
    if (homeTeam.goals > awayTeam.goals) {
      return homeTeam.id;
    } else if (homeTeam.goals < awayTeam.goals) {
      return awayTeam.id;
    } else if (this.isMatchEndedWithPenalties(homeTeam, awayTeam)) {
      if (homeTeam.penalty > awayTeam.penalty) {
        return homeTeam.id;
      } else if (homeTeam.penalty < awayTeam.penalty) {
        return awayTeam.id;
      }
    }
  }

  static isMatchEndedWithPenalties(homeTeam: MatchTeam, awayTeam: MatchTeam): boolean {
    return homeTeam.penalty !== null && awayTeam.penalty !== null;
  }
}
